const doc = [({"ext_balance":({"description":"Pago por comisiones"}), "reverse_charge":"El destinatario del servicio es responsable del IVA de acuerdo con el mecanismo de carga inversa."})];
module.exports = doc.length <= 1 ? doc[0] : doc;